import React, { useEffect, useState } from "react";
import { AppBar, Container, Typography, Tabs, Tab, Box, Toolbar } from "@mui/material";
import { useLocation } from "react-router-dom";

import DryMatterConversionTool from "../components/DryMatterConversionTool";
import CaloriesCalculator from "../components/CaloriesCalculator";

import "../style/Tools.css";

const resolveTabFromLocation = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const rawTab = (searchParams.get("tab") || location.hash.replace("#", "") || "").toLowerCase();

  if (["dry-matter", "dry-matter-conversion", "dmb", "conversion"].includes(rawTab)) {
    return 1;
  }

  return 0;
};

const Tools = () => {
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState(() => resolveTabFromLocation(location));

  useEffect(() => {
    setTabIndex(resolveTabFromLocation(location));
  }, [location]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="tools-container">
      {/* Use the shared page header classes */}
      <div className="page-header">
        <h1 className="page-title">Tools</h1>
        <img
          src="/picky-kitty/tools.png"
          alt="The Picky Kitty Tools"
          className="header-image"
        />
      </div>

      <Container maxWidth="lg" sx={{ py: 2 }}>


        {/* Menu Tabs for navigation */}
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          sx={{ mb: 3 }}
        >
          <Tab label="Calories Simulator" />
          <Tab label="Dry Matter Conversion" />
        </Tabs>

        {/* Content based on selected tab */}
        <Box>
          {tabIndex === 0 && (
            <CaloriesCalculator />
          )}
          {tabIndex === 1 && (
            <DryMatterConversionTool />
          )}
        </Box>
      </Container>
    </div>
  );
};

export default Tools;